var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMk2Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 24,
    viewBox: "0 0 94 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2815 22.2156H37.4433V7.80699L43.1551 22.2156H44.6763L50.3594 7.80699V22.2156H54.9805V1.69337H48.953L44.2171 14.4659L39.4238 1.69337H33.2815V22.2156Z",
    fill: "#00704F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6806 22.2156H64.3304V13.0021L71.4199 22.2156H76.8447L68.32 11.3948L76.4428 1.66467H71.506L64.3304 10.5337V1.69337H59.6806V22.2156Z",
    fill: "#00704F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7197 22.2156H84.3982V1.69337H79.7197V22.2156Z",
    fill: "#00704F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.301 22.2156H93.9795V1.69337H89.301V22.2156Z",
    fill: "#00704F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2644 15.7461C15.4954 16.2081 16.1594 16.2081 16.3904 15.7461C16.3904 15.7461 19.0178 10.6068 19.6241 9.39415C20.2305 8.1815 20.2593 6.82449 19.6241 5.55409C18.5847 3.44639 16.0151 2.60909 13.9074 3.67737C11.7997 4.74566 10.9912 7.37307 12.0306 9.39415C13.0701 11.4152 15.2644 15.7461 15.2644 15.7461ZM15.8418 5.52522C16.9679 5.52522 17.8629 6.42027 17.8629 7.54631C17.8629 8.67234 16.9679 9.56739 15.8418 9.56739C14.7158 9.56739 13.8207 8.67234 13.8207 7.54631C13.8207 6.44915 14.7158 5.52522 15.8418 5.52522Z",
    fill: "#00704F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2684 3.45322L8.41312 1.03742L0.771484 5.80896V23.9016L8.39425 19.137L15.786 23.7571L23.8914 18.6033V0.503296L19.3559 3.38699C19.7793 3.78741 20.1399 4.26845 20.413 4.82217C20.4904 4.97702 20.5597 5.13293 20.6208 5.28963L21.5813 4.67108V17.3231L16.9406 20.3118V16.278C16.6774 16.7933 16.5125 17.1158 16.5125 17.1158C16.2339 17.673 15.4329 17.673 15.1543 17.1158C15.1543 17.1158 14.951 16.7147 14.6305 16.0829V20.3118L9.54883 17.1352V4.47491L11.0225 5.39836C11.2839 4.67472 11.7047 4.00491 12.2684 3.45322ZM7.23922 17.1347V4.49378L3.08109 7.08962V19.7338L7.23922 17.1347Z",
    fill: "#00704F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk2Logo);
export default __webpack_public_path__ + "static/media/mk2_logo.690b6c01d7c227152e9bd2dee8e8bdbf.svg";
export { ForwardRef as ReactComponent };